import { ActivityList } from "../../../../api/types";
import React from "react";
import { Image, Text, View } from "@react-pdf/renderer";
import { getPreviewUrl } from "../../../../api/base";
import { AppendixStyle } from "./AppendixContent";

interface DedupedActivitiesProps {
	activities: ActivityList;
}
export const DedupedActivities: React.FC<DedupedActivitiesProps> = ({
	activities,
}): JSX.Element => {
	let dedupedActivies: ActivityList = [];
	if (activities) {
		activities.forEach((activity) => {
			if (
				dedupedActivies.findIndex(
					(dedupedActivity) => dedupedActivity.questId === activity.questId,
				) === -1
			) {
				dedupedActivies = [...dedupedActivies, activity];
			}
		});
	}
	const activityRows: ActivityList[] = new Array(
		Math.floor(dedupedActivies.length / 3),
	);
	let index = 0;
	for (const activity of dedupedActivies) {
		const rowIndex = Math.floor(index / 3);
		activityRows[rowIndex] = [...(activityRows[rowIndex] || []), activity];
		index++;
	}

	return (
		<View style={AppendixStyle.activityContainer}>
			{activityRows.map((row, i) => (
				<View key={i} style={AppendixStyle.activityRow}>
					{row.map((activity, j) => (
						<View key={j} style={AppendixStyle.activityEntry}>
							<Image
								style={AppendixStyle.image}
								src={{
									uri: getPreviewUrl(activity.questId),
									method: "GET",
									headers: { "Access-Control-Allow-Origin": "*" },
									body: "",
								}}
							/>
							<Text style={AppendixStyle.imgCaption}>{activity.name}</Text>
						</View>
					))}
				</View>
			))}
		</View>
	);
};
